import type { DueOutlook, QuoteDetailPublic } from "@common/client"
import { formatShortDate } from "@common/lib/date-utils"

export const DUE_OUTLOOKS = [
  "within_horizon",
  "beyond_horizon",
] as const satisfies readonly DueOutlook[]

export function dueOutlookLabel(
  quote: QuoteDetailPublic,
  outlook: DueOutlook,
): string {
  const horizon = quote.due_horizon ? formatShortDate(quote.due_horizon) : ""
  switch (outlook) {
    case "within_horizon":
      return `Due by ${horizon}`
    case "beyond_horizon":
      return `Due after ${horizon}`
  }
}
